module.exports = __webpack_public_path__ + "static/media/left-arrow.4d2993cf.svg";